var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "600px",
        title: _vm.businessNo,
        visible: _vm.visible,
        "before-close": _vm.modalClose,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "custom-class": "onlineContact"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "msgBox",
          staticClass: "chatLogs",
          on: { scroll: _vm.onScroll }
        },
        [
          _vm.loading
            ? _c("div", { staticClass: "loading" }, [
                _c("i", { staticClass: "el-icon-loading" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.msgList, function(item, index) {
            return _c(
              "el-row",
              {
                key: index,
                staticClass: "clearfix",
                class: {
                  otherTxt: item.userNo != _vm.sendUserNo,
                  selfTxt: item.userNo == _vm.sendUserNo
                }
              },
              [
                _c(
                  "el-col",
                  {
                    attrs: {
                      span: 12,
                      offset: item.userNo == _vm.sendUserNo ? 12 : 0
                    }
                  },
                  [
                    _c("div", { staticClass: "userName" }, [
                      _vm._v(_vm._s(item.userNo))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(
                        "\n            " + _vm._s(item.msg) + "\n          "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sending clearfix" },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 3,
              resize: "none",
              placeholder: ""
            },
            model: {
              value: _vm.message,
              callback: function($$v) {
                _vm.message = $$v
              },
              expression: "message"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.send }
                },
                [_vm._v(_vm._s(_vm.$t("onlineContact.send")))]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-139fa7ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-139fa7ed","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/onlineContact.vue
// module id = null
// module chunks = 